import {auth, put, get, url} from "../../app/services/Backend/HttpRequest"

export default {
  namespaced: true,
  state() {
    return {
      collection: []
    }
  },
  mutations: {
    collection(state, payload) {
      state.collection = payload
    },
    update(state, payload) {
      state.collection = state.collection.map(property => {
        if(property.uuid === payload.uuid){
          property = payload
        }

        return property
      })
    }
  },
  actions: {
    collection({rootState, commit}, payload) {
      const input = {
        url: url('auth/settings/properties'),
        payload,
        headers: auth(rootState)
      }

      return get(input).then(response => {
        commit('collection', response.data)
      })
    },
    update({rootState, commit}, {uuid, payload}) {
      const input = {
        url: url(`auth/settings/properties/${uuid}`),
        payload,
        headers: auth(rootState)
      }

      return put(input).then(response => {
        commit('update', response.data)
      })
    },
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/properties.js